import { axios, base } from '../http';

/**
 * 课堂质量点评后台接口。创建于 2026-09-21
 */

export const getClassroomQualityConfig = (params) => {
  return axios.get(`${base}/api/ClassroomQuality/GetConfig`, { params });
};

export const saveClassroomQualityConfig = (data) => {
  return axios.post(`${base}/api/ClassroomQuality/SaveConfig`, data);
};

/** 学校等级配置 */
export const getClassroomQualityGrades = (params) => {
  return axios.get(`${base}/api/ClassroomQuality/GetGrades`, { params });
};

export const saveClassroomQualityGrades = (data) => {
  return axios.post(`${base}/api/ClassroomQuality/SaveGrades`, data);
};

export const resetClassroomQualityDefaultGrades = (params) => {
  return axios.post(`${base}/api/ClassroomQuality/ResetDefaultGrades`, null, { params });
};

export const getClassroomQualityCategoryTree = (params) => {
  return axios.get(`${base}/api/ClassroomQuality/GetCategoryTree`, { params });
};

export const saveClassroomQualityCategory = (data) => {
  return axios.post(`${base}/api/ClassroomQuality/SaveCategory`, data);
};

export const deleteClassroomQualityCategory = (params) => {
  return axios.post(`${base}/api/ClassroomQuality/DeleteCategory`, null, { params });
};

export const saveClassroomQualityItem = (data, schoolId) => {
  return axios.post(`${base}/api/ClassroomQuality/SaveItem?schoolId=${schoolId}`, data);
};

export const deleteClassroomQualityItem = (params) => {
  return axios.post(`${base}/api/ClassroomQuality/DeleteItem`, null, { params });
};

/** 批量导入点评项（一级/二级分类 + 三级项） */
export const importClassroomQualityItems = (data) => {
  return axios.post(`${base}/api/ClassroomQuality/ImportItems`, data);
};

export const getClassroomQualityRecords = (params) => {
  return axios.get(`${base}/api/ClassroomQuality/GetRecords`, { params });
};

export const getClassroomQualityClassRanking = (params) => {
  return axios.get(`${base}/api/ClassroomQuality/GetClassRanking`, { params });
};

/** 班级扣分汇总 */
export const getClassroomQualityClassDeductSummary = (params) => {
  return axios.get(`${base}/api/ClassroomQuality/GetClassDeductSummary`, { params });
};

/** 导出点评明细 */
export const exportClassroomQualityRecords = (params) => {
  return axios.get(`${base}/api/ClassroomQuality/ExportRecords`, { params, responseType: 'blob' });
};

/** 导出班级扣分汇总 */
export const exportClassroomQualityClassDeductSummary = (params) => {
  return axios.get(`${base}/api/ClassroomQuality/ExportClassDeductSummary`, { params, responseType: 'blob' });
};

export const getClassroomQualityRecordDetail = (params) => {
  return axios.get(`${base}/api/ClassroomQuality/GetRecordDetail`, { params });
};

export const deleteClassroomQualityReview = (params) => {
  return axios.post(`${base}/api/ClassroomQuality/DeleteReview`, null, { params });
};

export const getClassroomQualityAdminList = (params) => {
  return axios.get(`${base}/api/ClassroomQuality/GetAdminList`, { params });
};

export const saveClassroomQualityAdmin = (data) => {
  return axios.post(`${base}/api/ClassroomQuality/SaveAdmin`, data);
};

export const deleteClassroomQualityAdmin = (params) => {
  return axios.post(`${base}/api/ClassroomQuality/DeleteAdmin`, null, { params });
};

export const getClassroomQualitySpecialTimes = (params) => {
  return axios.get(`${base}/api/ClassroomQuality/GetSpecialTimes`, { params });
};
